import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import CircularProgressLoader from '../../components/CircularProgressLoader';
import { STATIC_CONTENT_ROUTES, ABOUT, CONTACT_US, PRIVACY_POLICY, CANCEL_POLICY, FREQUENTLY_ASKED_QUESTIONS } from '../../assets/constants/PageList';

const FULL_SIZE_IFRAME_STYLE = { width: '100%', height: '100%', flex: 1, alignSelf: 'stretch', border: 'none' };

const PAGE_CONFIG = {
    [STATIC_CONTENT_ROUTES[ABOUT]]: { className: 'about-screen-page', contentKey: 'aboutContent', iframeClassName: 'iframe-view' },
    [STATIC_CONTENT_ROUTES[CONTACT_US]]: { className: 'contact-us-page', contentKey: 'contactUsContent', iframeStyle: FULL_SIZE_IFRAME_STYLE },
    [STATIC_CONTENT_ROUTES[PRIVACY_POLICY]]: { className: 'privacy_policy_page', contentKey: 'privacyPolicyContent', iframeStyle: FULL_SIZE_IFRAME_STYLE },
    [STATIC_CONTENT_ROUTES[CANCEL_POLICY]]: { className: 'cancel_policy_page', contentKey: 'cancellationPolicyContent', iframeStyle: FULL_SIZE_IFRAME_STYLE },
    [STATIC_CONTENT_ROUTES[FREQUENTLY_ASKED_QUESTIONS]]: { className: 'faq-page', contentKey: 'faqHtmlContent', iframeOnly: true, iframeClassName: 'faq-container' },
};

const StaticContentPage = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { className, contentKey, iframeOnly, iframeClassName, iframeStyle } = PAGE_CONFIG[location.pathname] || {};

    const [loading, setLoading] = useState(true);

    const content = t(contentKey);
    const isUrl = content?.startsWith('https');
    const hideLoaderOnLoad = () => setLoading(false);

    if (iframeOnly) {
        return (
            <Box className={className}>
                {loading && <CircularProgressLoader message={t('pleaseWaitText')} />}
                <iframe src={content} loading='eager' className={iframeClassName} title={className} onLoad={hideLoaderOnLoad} />
            </Box>
        );
    }

    return (
        <Box className={className}>
            <Box className="main-container">
                <Box className="main">
                    {isUrl ? (
                        <>
                            {loading && <CircularProgressLoader message={t('pleaseWaitText')} />}
                            <iframe src={content} title={className} className={iframeClassName} style={iframeStyle} onLoad={hideLoaderOnLoad} />
                        </>
                    ) : (
                        <Box dangerouslySetInnerHTML={{ __html: content }} />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default StaticContentPage;
